<template>
    <div>
      <span class="sec-description">{{ $t('diagnostic.consume.title') }}<br><i v-if="sectionDescription">{{sectionDescription}}</i></span>
      <apexchart class="canvas" :width="size" height="600" type="radar" :options="chartOptions" :series="consume"></apexchart>
    </div>
</template>

<script>
import i18n from '@/i18n';

export default {
  props: {size: String},
  data () {
    return {
      chartOptions: {
          chart: {
            toolbar: {
              show: false
            }
          },
          colors: ['#004412', '#FFBB0C', '#894412'],
          plotOptions: {
                radar: {
                    size: 250,
                    polygons: {
                        strokeColor: '#e9e9e9',
                        fill: {
                            colors: ['#f8f8f8', '#fff']
                        }
                    }
                }
          },
          markers: {
                size: 8,
                colors: ['#FFFFFF'],
                strokeColor: ['#004412', '#FFBB0C', '#894412'],
                strokeWidth: 2,
          },
          stroke: {
            width: 3,
            colors: ["#004412", "#dd9e00", "#a39489"]
          },
          fill: {
              opacity: 0.1
          },
          tooltip: {
            x: {
              formatter: function (val) {
                return val
              }
            },
            y: {
              formatter: function (val) {
                return Math.abs(val) + "%"
              }
            }
          },
          xaxis: {
            // categories: ['BIG EVM MEAL', 'FAMILY', 'COMBO MEALS', 'LATE NIGHT', 'SWEET TREAT', 'SNACKS & DRINKS', 'LIGHT BREAKFAST']
            categories: [this.$t('diagnostic.consume.categories.core_premium'), this.$t('diagnostic.consume.categories.families'), this.$t('diagnostic.consume.categories.affordable'), this.$t('diagnostic.consume.categories.late_night')]
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return Math.abs(Math.round(val))+ "%"
              }
            }
          }
        }
    }
  },
  computed: {
    sectionDescription() {
      var section = this.$store.getters['locations/getDiagnosticDescriptions']['consume']
      if (section && section.description) {
        return section.description;
      } else return false;
    },

    selectedLocation() {
      return this.restaurant = this.$store.getters['locations/getSelectedLocation'];
    },

    consume() {
      var data = this.$store.getters['locations/getConsume'];
      var result = [];

      if ( data.length != 0 ) {
        if (this.selectedLocation.id in data) { // Realiza la comprabación de si hay datos sobre este restaurante
          var restaurant = {
            name: this.selectedLocation.name,
            data: [data[this.selectedLocation.id][1], data[this.selectedLocation.id][2], data[this.selectedLocation.id][3], data[this.selectedLocation.id][4], data[this.selectedLocation.id][5], data[this.selectedLocation.id][6], data[this.selectedLocation.id][7]],
          };
          result.push(restaurant);
        }     

        // if ('account' in data) { // Realiza la comprabación de si hay datos en la cuenta
        //   var account = {
        //     name: 'Cuenta',
        //     data: [data['account'][1], data['account'][2], data['account'][3], data['account'][4], data['account'][5], data['account'][6], data['account'][7]],
        //   };
        //   result.push(account);
        // }

        var nacional = {
          name: this.$t('diagnostic.consume.nacional'),
          data: [data['nacional'][1], data['nacional'][2], data['nacional'][3], data['nacional'][4], data['nacional'][5], data['nacional'][6], data['nacional'][7]],
        };
        result.push(nacional);

        return result;
      }
    }
  },
  methods: {
  },
  watch: {
    selectedLocation () {
      if (this.selectedLocation==undefined){
        this.$store.getters['locations/getSelectedLocation'];
      }
        this.$store.dispatch('locations/loadConsume', this.selectedLocation.id);
        this.consume;
     },
  },
  created() {
    this.$store.dispatch('locations/loadConsume', this.selectedLocation.id);
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .sec-description {
    display: block;
    color: #999;
    margin-bottom: 40px;
  }

  .consume {
    margin: 0 auto;
    border-color: white;
    width: 80%;

    &.weekend {
      margin-top: 40px;
    }

    .hide {
      visibility: hidden !important;
      opacity: 0 !important;
    }
  }

</style>
